<template>
  <ul class="scroll">
    <li
      class="scroll__item"
      v-for="option in options"
      v-bind:key="option.selector"
      v-bind:class="{ 'scroll__item-active': option.selector === active }"
      v-on:click="$emit('select', option.selector)"
    >{{ option.name }}</li>
  </ul>
</template>

<script>
export default {
  name: 'ScrollBox',

  props: {
    options: {
      type: Array,
      required: true,
    },

    active: String,
  },
};
</script>
